
import styles from './button_group.module.sass'

import BlockWrapper from './layout/block_wrapper'

import Button from './basic/button'
import ScrollAnimation from './layout/scroll_animation'

function ButtonGroup(props) {
	const fields = props.fields

	return <BlockWrapper {...props} className={styles.button_group} >
		<ScrollAnimation styles={styles}>
			{fields.buttons && fields.buttons.map((button, index) => {
				return <Button key={index} fields={button}>{button.button.title}</Button>
			})}
		</ScrollAnimation>
	</BlockWrapper>
}

export default ButtonGroup